/*
@license
  Fetch by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://help.archetypethemes.co/en/articles/206592

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Fetch theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Fix 16/9 - uklid po navratu z bfcache

    Tema nemelo ani jeden pageshow/pagehide handler. Kdyz prohlizec vrati
    stranku z bfcache (tlacitko Zpet), NEspusti se load ani DOMContentLoaded,
    takze zadny kod neuklidi stav, ve kterem uzivatel ze stranky odesel:

      - product.gallery.photoswipe.js dava na <html> tridu pswp-open-in-ios
        a CSS na ni aplikuje `.pswp-open-in-ios body > * { display: none }`.
        Sunda se jen v callbacku destroy, ktery po bfcache nikdy neprijde
        -> po navratu Zpet je CELY obsah display:none = prazdna obrazovka.
      - lockScroll() z header.drawer.js necha inline overflow:hidden na html
        i body, util.a11y.js tridu lock-scroll -> zamcene rolovani.
      - AJAX preloader .unload na kolekci necha mrizku na opacity: 0.2.

    Handler nize se spusti POUZE pri obnove z bfcache (event.persisted) a jen
    uklizi. Nic nerenderuje ani nefetchuje.
  ==============================================================================*/
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;

    var html = document.documentElement;
    var body = document.body;

    [
      "pswp-open-in-ios",
      "photoswipe-open",
      "modal-open",
      "modal-closing",
      "lock-scroll",
    ].forEach(function (trida) {
      html.classList.remove(trida);
    });

    body.classList.remove("predictive-overflow-hidden");
    html.style.overflow = "";
    body.style.overflow = "";
    body.style.height = "";

    document.querySelectorAll(".unload").forEach(function (el) {
      el.classList.remove("unload");
    });
    document.querySelectorAll("predictive-search.is-active").forEach(function (el) {
      el.classList.remove("is-active");
    });
    document.querySelectorAll('[data-tool-tip-open="true"]').forEach(function (el) {
      el.setAttribute("data-tool-tip-open", "false");
    });
    document.querySelectorAll(".modal--is-active").forEach(function (el) {
      el.classList.remove("modal--is-active");
    });

    var nav = document.querySelector(".site-nav__bottom");
    if (nav) {
      nav.style.transform = "";
      nav.style.visibility = "";
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
  
})();
